import { useCallback, useContext, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import SurveyQuestionsList from './survey-questions-list'
import { CurrentSociogramContext } from '@BUP/contexts/CurrentSociogramContext'
import { EnrollmentContext } from '@BUP/contexts/EnrollmentContext'
import { CourseContext } from '@BUP/contexts/CourseContext'

const SurveyData = ({ page }) => {
  const { dataCurrentSociogram } = useContext(CurrentSociogramContext)
  const enrollment = useContext(EnrollmentContext)
  const courses = useContext(CourseContext)
  const { currentSociogram } = dataCurrentSociogram
  const surveys = currentSociogram.surveys
  const enrollmentId = enrollment.id
  const course = courses[0]
  const courseTags = course.course.tags
  const courseGrade = courseTags.find(tag => tag.includes('grade'))

  const navigate = useNavigate()

  const handleNextPage = useCallback(() => {
    navigate(`/sociogram/survey/${page + 1}`)
  }, [page, navigate])

  const foundSurvey = useMemo(
    () => surveys.find(survey => survey.grade === courseGrade),
    [surveys, courseGrade]
  )

  if (!foundSurvey) return <p>No survey found</p>

  return (
    <SurveyQuestionsList
      enrollmentId={enrollmentId}
      survey={foundSurvey}
      page={page}
      nextPage={handleNextPage}
    />
  )
}

export default SurveyData
